import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
} from '@material-ui/core';
import { copyToClipboard } from 'shared-library/src/utils';
import {
  CloseIcon,
  CopyIcon,
} from 'shared-library/dist/components/material-icon';

const styles = (theme) => ({
  titleRoot: {
    margin: 0,
    padding: theme.spacing(2),
  },
  contentRoot: {
    padding: theme.spacing(2),
    overflowX: 'hidden',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  copyButton: {

  },
  fontWeightBold: {
    fontWeight: 'bold',
  },
  errorTitle: {
    padding: `0 ${theme.spacing(1)}px`,
    backgroundColor: 'rgba(255,51,75,0.2)',
  },
  infoTitle: {
    padding: `0 ${theme.spacing(1)}px`,
    backgroundColor: 'rgba(51,177,255,0.7)',
  },
});
const useStyles = makeStyles(styles);

function ExceptionDetail(props) {
  const {
    open: originOpen,
    onClose,
    errorInfo: {
      informationList: {
        path = [],
        message,
      } = {},
      exceptionDetail: {
        status,
        statusText,
        config: {
          url,
          method,
          headers,
          data,
        } = {},
      } = {},
    },
  } = props;
  const [open, setOpen] = useState(originOpen);
  const classes = useStyles(styles);
  const contentRef = useRef(null);

  const handleClose = () => {
    setOpen(false);
    onClose && onClose();
  };

  const handleCopy = () => {
    copyToClipboard(contentRef.current.innerText);
  };

  useEffect(() => {
    if (originOpen !== open) {
      setOpen(originOpen);
    }
  }, [originOpen, open, setOpen]);

  return (
    <Dialog
      maxWidth="lg"
      onClose={handleClose}
      aria-labelledby="exception-detail-dialog-title"
      open={open}
    >
      <DialogTitle disableTypography className={classes.titleRoot} id="exception-detail-dialog-title">
        <Typography variant="h6">More exception detail</Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers className={classes.contentRoot} ref={contentRef}>
        <Typography component="div" paragraph gutterBottom>
          <Typography component="span" variant="subtitle1" className={classes.fontWeightBold}>Error</Typography>
          <div>
            <Typography component="span" className={classes.errorTitle}> message </Typography>
            <Typography component="span">{message}</Typography>
          </div>
          {path && (
            <div>
              <Typography component="span" className={classes.errorTitle}> path </Typography>
              <Typography component="span">{path.join('.')}</Typography>
            </div>
          )}
        </Typography>
        <Typography component="div" paragraph gutterBottom>
          <Typography component="span" variant="subtitle1" className={classes.fontWeightBold}>Request</Typography>
          <div>
            <Typography component="span" className={classes.infoTitle}> url </Typography>
            <Typography component="span">{url}</Typography>
          </div>
          <div>
            <Typography component="span" className={classes.infoTitle}> method </Typography>
            <Typography component="span">{method}</Typography>
          </div>
          <div>
            <Typography component="span" className={classes.infoTitle}> headers </Typography>
            <Typography component="span">{JSON.stringify(headers)}</Typography>
          </div>
          <div>
            <Typography component="span" className={classes.infoTitle}> data </Typography>
            <Typography component="span">{data}</Typography>
          </div>
        </Typography>
        <Typography component="div" paragraph gutterBottom>
          <Typography variant="subtitle1" className={classes.fontWeightBold}>Response</Typography>
          <div>
            <Typography component="span" className={classes.infoTitle}> status </Typography>
            <Typography component="span">{status}</Typography>
          </div>
        </Typography>
      </DialogContent>
      <DialogActions>
        <IconButton
          role="button"
          aria-label="copy"
          color="primary"
          className={classes.copyButton}
          onClick={handleCopy}
        >
          <CopyIcon color="primary" />
        </IconButton>
      </DialogActions>
    </Dialog>
  );
}

ExceptionDetail.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  errorInfo: PropTypes.shape({
    informationList: PropTypes.shape({
      path: PropTypes.arrayOf(PropTypes.string),
      message: PropTypes.string,
    }),
    exceptionDetail: PropTypes.shape({
      status: PropTypes.number,
      statusText: PropTypes.string,
      config: PropTypes.shape({
        url: PropTypes.string,
        method: PropTypes.string,
        headers: PropTypes.shape({}),
        data: PropTypes.string,
      }),
    }),
  }),
};

ExceptionDetail.defaultProps = {
  open: false,
  onClose: undefined,
  errorInfo: {},
};

export default ExceptionDetail;
